import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TimeRecordExportService } from './time-record-export.service';
import { FilterMatchMode, LazyLoadEvent, MessageService, SelectItem } from 'primeng/api';
import Swal from 'sweetalert2';
import { helperService } from 'src/app/utils/helper';
import { matchModeOptionsDateList } from 'src/app/utils/filterDropDownData';

@Component({
    selector: 'app-time-record-export',
    templateUrl: './time-record-export.component.html',
    styleUrls: ['./time-record-export.component.scss'],
    standalone: false
})
export class TimeRecordExportComponent implements OnInit {

  
  loading: boolean = false;
  totalRecords: number = 0;
  first: number = 1;
  cols:any[]=[];
  previewCols:any[]=[];
  gridCustomMessage:any=''
  previewData:any[]=[];
  timeRecordJobs:any[]=[];
  showTrDialog:Boolean=false;
  trForm:any=''
  title:any=''
  lazyloadEvent: any;
  matchModeOptionsDate: SelectItem[]=matchModeOptionsDateList;
  exportSubscription:any=null;

  constructor(private timeRecordExportService:TimeRecordExportService,private readonly messageService: MessageService,private helperService: helperService) {
    
    this.cols = [
      { field: 'id' },
      { field: 'createdDate'},
      { field: 'description' },
      { field: 'createdBy' },
      { field: 'recordsCount' },
    ];
    this.previewCols = [
      { field: 'dateCreated' },
      { field: 'orgName'},
      { field: 'matterName' },
      { field: 'projectName' },
      { field: 'taskName' },
      { field: 'timeRecDesc' },
      { field: 'expTrDuration' },
      { field: 'billingStatus' }
    ];
    this.trForm = new UntypedFormGroup({
      id: new UntypedFormControl(''),
      taskName: new UntypedFormControl(''),
      projectName: new UntypedFormControl(''),
      organizationName: new UntypedFormControl(''),
      matterName: new UntypedFormControl(''),
      employeeName: new UntypedFormControl(''),
      timeEstimate: new UntypedFormControl(''),
      billingStatus: new UntypedFormControl(''),
      billRate: new UntypedFormControl(''),
      payRate: new UntypedFormControl(''),
      notes: new UntypedFormControl(''),
    });

   }

  ngOnInit(): void {
  }
  generateData(){
    this.loading=true;
    this.timeRecordExportService.generateExportData().subscribe(res=>{
      if(res===null){
        this.loading=false;
        Swal.fire("No records to Export.");
      }
      if(res.data.statusCode==200){
        this.loading=false;
          this.loadExportGrid(this.lazyloadEvent);
      }

    })
  }
  preview(trData:any){
    this.title="Preview Data";
    this.previewData=trData["batchDetails"];
    this.trForm.patchValue(trData["batchDetails"]);
    this.trForm.disable();
    this.showTrDialog=true;
  
  }

  loadExportGrid(event:LazyLoadEvent){
    this.gridCustomMessage=''
    this.loading=true;
    this.lazyloadEvent=event;
    this.timeRecordJobs=[]
    event.first = event.first ? event.first : 1;
    event.rows = event.rows ? event.rows : 10;
    
    let payload=this.helperService.generateEventPayload(event);
    if (this.exportSubscription) 
      this.exportSubscription.unsubscribe();
    this.exportSubscription = this.timeRecordExportService.getAllBatchListPages(Math.floor(event.first / event.rows + 1), event.rows,payload).subscribe((res) =>{
          this.totalRecords=res?res.customValues?.totalNumberOfRecords:0; 
          this.timeRecordJobs=res.data;
          this.loading=false;
      }, res => {
        this.loading = false;
        this.gridCustomMessage=res.error.message?res.error.message:'';
      });
  }
  download( trData:any){
    console.log(trData)
    this.timeRecordExportService.downloadBatch(trData.id).subscribe(res =>{
      const responseBody = res.body;
      if(res.headers.get('Content-Type')=="application/octet-stream"&& responseBody instanceof ArrayBuffer){
        const contentDisposition:any = res.headers.get('Content-Disposition');
        let fn;
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch && filenameMatch[1]) {
          fn= filenameMatch[1].replace(/['"]/g, '');
        }
        this.saveFile(responseBody,fn);
      }
      else if (responseBody !== null){
        Swal.fire("Nothing to Download.");
      }
    },
    (error) => {
      console.error('Error fetching data', error);
    })
  }

  closeDialog(){
    this.loadExportGrid(this.lazyloadEvent);
  }

  saveFile(data: ArrayBuffer,filename:any) {
    const blob = new Blob([data], { type: 'application/octet-stream' });
    const downloadLink = document.createElement('a');
    
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = filename; 
    downloadLink.click();
  
    URL.revokeObjectURL(downloadLink.href); 
  }
  
}
